import { baseApiUrl } from '@fund-base/constants/general/general.constants';

export const BaseSavedSearchesRoute = `${baseApiUrl}/saved-searches`;
